import {
    ChangeDetectionStrategy,
    Component,
    ComponentRef,
    inject,
    Input,
    OnChanges,
    SimpleChanges,
    ViewContainerRef,
} from '@angular/core';
import { Contract } from '@models/contract';
import { ContractWidget, ContractWidgetConfig, DEFAULT_CONTRACT_WIDGETS } from '@models/contract-widgets';
import { Product } from '@models/product';
import { ProductsService } from '../../../products/products.service';

@Component({
    selector: 'app-contract-widget-container',
    standalone: true,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractWidgetContainerComponent implements OnChanges {
    @Input({ required: true }) public contract: Contract;

    private productsService = inject(ProductsService);
    private viewContainerRef = inject(ViewContainerRef);

    private currentProduct?: Product;
    private activeWidgets: ComponentRef<ContractWidget>[] = [];
    private defaultWidgets: ContractWidgetConfig[] = inject(DEFAULT_CONTRACT_WIDGETS);

    public ngOnChanges(changes: SimpleChanges): void {
        const contractChanges = changes['contract']?.currentValue as Contract;

        if (contractChanges) {
            const product = this.productsService.getCanonicalByInsuranceType(contractChanges.insuranceType);

            if (this.currentProduct?.slug !== product.slug) {
                this.initWidgets(product.portalConfig?.widgets);
                this.currentProduct = product;
            }
            this.updateWidgets(contractChanges);
        }
    }

    private updateWidgets(contract: Contract): void {
        if (this.activeWidgets?.length) {
            this.activeWidgets.forEach((widget: ComponentRef<ContractWidget>) => widget.setInput('contract', contract));
        }
    }

    private initWidgets(widgets?: ContractWidgetConfig[]): void {
        if (this.activeWidgets?.length) {
            this.viewContainerRef.clear();
            this.activeWidgets = [];
        }
        (widgets ?? this.defaultWidgets).forEach((widgetConfig: ContractWidgetConfig) => {
            const widgetRef = this.viewContainerRef.createComponent(widgetConfig.component);
            this.activeWidgets.push(widgetRef);
        });
    }
}
